import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./../../../refractCommon/components/DragAndDropList.css";
import Gradient from "./Gradient";
import { generateUID } from "../../Utils/generateUID";
import { useState, useEffect } from "react";

export default function DragAndDropGradientList({
  items,
  dataPath,
  dispatch,
  boardSelection,
  userIsPro,
  environment,
}) {
  const [localItems, setLocalItems] = useState([]);

  useEffect(() => {
    setLocalItems(items);
  }, [setLocalItems, items]);

  const handleDrop = async (droppedItem) => {
    if (!droppedItem.destination) return; // Ignore drop outside droppable container
    var updatedList = [...localItems];
    // Remove dragged palette
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped palette
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State
    setLocalItems(updatedList);

    await dispatch({
      path: dataPath + "._order",
      data: droppedItem.draggableId,
      index: droppedItem.destination.index,
    });
  };

  function createNewItem() {
    let uid = generateUID();
    let gradient = {
      gradient_colors:
        "linear-gradient(90deg, rgb(250, 209, 6) 0%, rgb(250, 54, 11) 46%, rgb(0, 212, 255) 100%)",
      name: "",
      id: uid,
    };
    dispatch([
      {
        path: dataPath + "." + gradient.id,
        data: gradient,
      },
      {
        path: dataPath + "._order",
        data: gradient.id,
        index: 0,
      },
    ]);
  }

  return (
    <div className="cs1 ce12 grid">
      {dispatch && (
        <button
          onClick={createNewItem}
          className="button button-tertiary button-small mb-0 cs6 ml-32 mt--8"
          type="button"
          aria-label="label">
          <span className="icon-plus"></span>
        </button>
      )}
      {/* <pre className="cs1 ce12" style={{ overflow: "auto" }}>{JSON.stringify(items, undefined, 2)}</pre> */}

      <DragDropContext onDragEnd={handleDrop}>
        <Droppable droppableId="list-container">
          {(provided) => (
            <div
              className="list-container cs1 ce12 grid"
              {...provided.droppableProps}
              ref={provided.innerRef}>
              {localItems.map(
                (item, index) =>
                  item?.id && (
                    <Draggable
                      key={item?.id}
                      draggableId={item?.id}
                      index={index}>
                      {(provided) => (
                        <div
                          className="cs1 ce12 grid mb-16"
                          ref={provided.innerRef}
                          {...provided.draggableProps}>
                          <Gradient
                            item={item}
                            dataPath={dataPath}
                            dispatch={dispatch}
                            dragHandleProps={{ ...provided.dragHandleProps }}
                            boardSelection={boardSelection}
                            userIsPro={userIsPro}
                            environment={environment}
                          />
                        </div>
                      )}
                    </Draggable>
                  )
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}
